<template>
  <div>
    <div class="digilam-vs-litholam-manufacturing-time">
      <img src="images/why-digital/manufacturing-benefits/dvsl_manufacturing_time.png" alt="">
    </div>
    <div class="lower-sidenote">
      <p class="title-sidenote">DigiFrame</p>
      <p class="subtitle-sidenote">September</p>
      <p class="subtitle-sidenote">100,000 Qty</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/scss/views/why-digital/manufacturing-time.scss';

.digilam-vs-litholam-manufacturing-time {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  height: 60vh;

  img {
    height: 30vh;
    width: auto;
    margin-top: 70px;
  }

}
</style>
